export default class  BalanceSheetActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_BALANCESHEET='GET_HELPER_BALANCESHEET';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static BEFORE_PRINT_BALANCESHEET='BEFORE_PRINT_BALANCESHEET';
  static PRINT_BALANCESHEET='PRINT_BALANCESHEET';
  static submit(){
    return {
      type:  BalanceSheetActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  BalanceSheetActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  BalanceSheetActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  BalanceSheetActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  BalanceSheetActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  BalanceSheetActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  BalanceSheetActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  BalanceSheetActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  BalanceSheetActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  BalanceSheetActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  BalanceSheetActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  BalanceSheetActions.GET_HELPER_BALANCESHEET,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  BalanceSheetActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: BalanceSheetActions.BEFORE_PRINT_BALANCESHEET,
    };
  }
  static print(printBalanceSheet){
    return {
      type: BalanceSheetActions.PRINT_BALANCESHEET,
      payload: printBalanceSheet
    };
  }
}